module.exports = __webpack_public_path__ + "static/media/mini.7940cf73.png";


//////////////////
// WEBPACK FOOTER
// ./src/marketingOnline/data/carImages/远程E200S冷藏车/mini.png
// module id = 720
// module chunks = 0